import "./Login.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import useFormWithValidation from "../../hooks/useFormWithValidation.jsx";
import mainApi from "../../utils/api.js";

export default function Login({ handleLogin, serverError }) {
  const { values, handleChange, resetForm, errors, isValid } =
    useFormWithValidation();

  const [registerEnabled, setRegisterEnabled] = useState(false);

  useEffect(() => {
    resetForm();
    mainApi
      .getRegisterStatus()
      .then((data) => setRegisterEnabled(data.registerStatus))
      .catch(() => setRegisterEnabled(false));
  }, [resetForm]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(values);
    localStorage.setItem("email", values.email);
  };

  const handleOverlayClick = () => {
    window.location.reload();
  };

  return (
    <main className="login">
      {/* overlay */}
      <div className="login__overlay" onClick={handleOverlayClick}></div>

      <form
        className="login__form"
        name="login"
        noValidate
        onSubmit={handleSubmit}
      >
        <h1 className="login__title">Glad to see!</h1>
        <div className="login__labels-container">
          <label className="login__label">
            <span className="login__label-text">E-mail</span>
            <input
              name="email"
              className={`login__input ${
                errors.email ? "login__input_error" : ""
              }`}
              onChange={handleChange}
              value={values.email || ""}
              type="email"
              autoComplete="email"
              required
            />
            <span className="login__error">{errors.email || ""}</span>
          </label>
          <label className="login__label">
            <span className="login__label-text">Password</span>
            <input
              name="password"
              className={`login__input ${
                errors.password ? "login__input_error" : ""
              }`}
              onChange={handleChange}
              value={values.password || ""}
              type="password"
              autoComplete="current-password"
              required
            />
            <span className="login__error">{errors.password || ""}</span>
          </label>
        </div>

        {serverError && (
          <span className="login__error login__error-message">
            {serverError}
          </span>
        )}

        <button
          type="submit"
          className={`login__button ${
            !isValid ? "login__button_disabled" : ""
          }`}
          disabled={!isValid}
        >
          Enter
        </button>

        {registerEnabled && (
          <span className="login__support">
            Not registered yet?&nbsp;
            <Link to="/signup" className="login__link">
              Sign Up
            </Link>
          </span>
        )}
      </form>
    </main>
  );
}
